module.exports = __webpack_public_path__ + "img/autosense-product-page-cover.7691a678.png";